import { useState, useEffect, useContext } from 'react'
import { ClientContext } from '../../../contexts/clientProvider'
import { RelatoriosContext } from '../../../contexts/relatoriosProvider'
import LoadingSpinner from '../../Loader/load'
import DataTable from '../../Table'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'

const FaturamentoAnexo = () => {
  const { clientes } = useContext(ClientContext);
  const { finanByAnexo } = useContext(RelatoriosContext);
  const [clients, setClients] = useState(null);
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [titulo, setTitulo] = useState(null);
  const [selectedClient, setSelectedClient] = useState("");

  useEffect(() => {
    let newClients = clientes ? clientes : [];
    setClients(newClients);
  }, [clientes]);

  const handleSelectClient = async (e) => {
    setLoading(true);
    const id = e.target.value;
    if (!id) {
      setSelectedClient("");
      setDados(null);
      setTitulo(null);
      setLoading(false);
      return;
    }
    
    const nTitulo = clients.find((client) => client.id === parseInt(id))?.nome;
    setTitulo(nTitulo);
    let nDados = await finanByAnexo(id);
    if(nDados){
      nDados = nDados.map((dado) => {
        return {
          ...dado,
          valor: `R$ ${dado.valor}`,
        }
      })
      setDados(nDados);
    }
    setLoading(false);
  }

  const headers = [
    { label: "Anexo", key: "nome", sortable: true },
    { label: "Situação", key: "status_local", sortable: false},
    { label: "Valor", key: "valor", sortable: true },
    { label: "Observações", key: "observacoes_local", sortable: false}
  ]

  return (
    <>
      <div className="flex flex-col sm:flex-row items-start sm:items-end justify-center gap-6 mb-8 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
        <div className="w-full sm:w-80">
          <BaseSelect
            label="Cliente"
            name="cliente"
            value={selectedClient}
            onChange={handleSelectClient}
            options={clients ? clients.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
            placeholder="Selecione o cliente"
            valueKey="id"
            labelKey="nome"
          />
        </div>
      </div>

        {loading && <LoadingSpinner />}
        {dados && <DataTable headers={headers} data={dados} itemsPerPage={5} exportButton={true} docTitle={`Financeiro por anexo do cliente ${titulo}`} />}
    </>
  );
}

export default FaturamentoAnexo